import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  CalculateBreedCostInput,
  CalculateBreedCostOutput,
  WebAppRoutes,
} from "types/web-app";

export const calculateBreedCost = async (
  accessToken: string,
  input: CalculateBreedCostInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.CALCULATE_BREED_COST,
      accessToken,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(input),
      },
    );

    const data =
      (await response.json()) as ServiceResponse<CalculateBreedCostOutput>;

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

